import gsap from "gsap";
import Swiper from "swiper";
import { FreeMode, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

const initApp = () => {
	console.log("======== DOM loaded successfully ========");
	console.log("%c#USEHEART", "color: #d3e0f7; font-size: 1.5rem;");

	// Mobile Menu Toggling
	const menuToggleBtn = document.querySelector("[js-menu-toggle-btn]");
	const nav = document.querySelector("[js-mobile-nav]");
	const menuToggleHandler = () => {
		const isOpen = menuToggleBtn.getAttribute("aria-expanded") === "true";
		if (isOpen) {
			// close menu
			closeMenu();
		} else {
			// open menu
			openMenu();
		}
	};

	const openMenu = () => {
		menuToggleBtn.setAttribute("aria-expanded", "true");
		gsap.set(nav, { css: { display: "block" } });
		gsap.fromTo(nav, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: "power3.inOut" });
	};

	const closeMenu = () => {
		menuToggleBtn.setAttribute("aria-expanded", "false");
		gsap.fromTo(nav, { autoAlpha: 1 }, { autoAlpha: 0, duration: 0.3, ease: "power3.inOut" });
		gsap.set(nav, { css: { display: "none" }, delay: 0.3 });
	};

	menuToggleBtn.addEventListener("click", menuToggleHandler);

	// Hero Switch
	const switchBtn = document.querySelector("[js-switch]");
	switchBtn.addEventListener("click", () => switchBtn.classList.toggle("--active"));

	// Marquee Strip
	const stripItemOne = document.querySelectorAll("[js-strip-item-one]");
	const stripItemTwo = document.querySelectorAll("[js-strip-item-two]");
	let xPercent = 0;

	const animateStrip = () => {
		requestAnimationFrame(animateStrip);

		if (xPercent <= -100) {
			xPercent = 0;
		}
		gsap.set(stripItemOne, { xPercent: xPercent });
		gsap.set(stripItemTwo, { xPercent: xPercent });
		xPercent -= 0.16;
	};
	animateStrip();

	// Principles slider
	const principlesSlider = new Swiper("[js-principles-slider]", {
		slidesPerView: "auto",
		spaceBetween: 20,
		slidesOffsetBefore: 28,
		slidesOffsetAfter: 28,
		modules: [FreeMode, Navigation],
		navigation: {
			nextEl: ".principles-slider-navigation .swiper-button-next",
			prevEl: ".principles-slider-navigation .swiper-button-prev",
		},
		freeMode: {
			enabled: true,
			sticky: true,
		},
		breakpoints: {
			992: {
				slidesOffsetBefore: 140,
				slidesOffsetAfter: 140,
			},
		},
	});

	// Feed slider
	const feedSlider = new Swiper("[js-feed-slider]", {
		slidesPerView: "auto",
		spaceBetween: 20,
		slidesOffsetBefore: 28,
		slidesOffsetAfter: 28,
		modules: [FreeMode, Navigation],
		freeMode: {
			enabled: true,
			sticky: true,
		},
		navigation: {
			nextEl: ".feed-slider-navigation .swiper-button-next",
			prevEl: ".feed-slider-navigation .swiper-button-prev",
		},
		breakpoints: {
			992: {
				slidesOffsetBefore: 140,
				slidesOffsetAfter: 140,
			},
		},
	});

	const videoSlider = new Swiper("[js-video-slider]", {
		slidesPerView: 1,
		spaceBetween: 30,
		modules: [Navigation, Pagination],
		pagination: {
			enabled: true,
			el: ".swiper-pagination",
		},
		navigation: {
			nextEl: ".video-slider-navigation .swiper-button-next",
			prevEl: ".video-slider-navigation .swiper-button-prev",
		},
	});

	const principleCardColors = [
		"#E6DFEA",
		"#F9F0D1",
		"#252525",
		"#CD0C24",
		"#DFEED7",
		"#E6DFEA",
		"#F9F0D1",
		"#252525",
		"#DCE1FA",
		"#CD0C24",
	];
	const darkColors = ["#CD0C24", "#252525"];
	const principleCards = document.querySelectorAll("[js-principle-card]");
	principleCards.forEach((card, idx) => {
		const cardBg = card.querySelector(".card-background");
		if (darkColors.includes(principleCardColors[idx % principleCardColors.length])) {
			cardBg.classList.add("--inverse");
		}
		cardBg.style.backgroundColor = principleCardColors[idx % principleCardColors.length];
	});

	// Join us Popup
	const popup = document.querySelector("[js-joinus-popup]");
	const popupShowBtn = document.querySelector("[js-show-popup]");
	const popupHideBtn = document.querySelector("[js-hide-popup]");

	const showPopup = () => {
		gsap.set(popup, { css: { display: "block" } });
		gsap.fromTo(popup, { x: "100%" }, { x: 0, duration: 1, ease: "expo.inOut" });
	};

	const hidePopup = () => {
		gsap.fromTo(popup, { x: 0 }, { x: "100%", duration: 1, ease: "expo.inOut" });
		gsap.set(popup, { css: { display: "none" }, delay: 1 });
	};

	popupShowBtn.addEventListener("click", showPopup);
	popupHideBtn.addEventListener("click", hidePopup);

	// Highlighted text animation
	const originalHLText = document.querySelector("#aboutSection .highlighted");
	const originalSpan = document.createElement("span");
	originalSpan.innerHTML = originalHLText.innerHTML;
	originalHLText.innerHTML = "";
	originalHLText.append(originalSpan);
	originalSpan.after(originalSpan.cloneNode(true));
	// originalHLText.after(originalHLText.cloneNode(true));
	//
	gsap.to(gsap.utils.toArray("#aboutSection .highlighted span"), {
		y: "-100%",
		duration: 10,
		ease: "linear",
		repeat: -1,
	});

	// Floating Navigation
	const floatingNav = document.querySelector(".floating-nav");
	gsap.set(floatingNav, { yPercent: 100, y: 60 });
	let showFloatingNavTween = gsap.to(floatingNav, 0.5, { yPercent: 0, y: 0, ease: "expo.inOut" }).pause();

	const floatingNavVisibilityHandler = () => {
		if (showFloatingNavTween.isActive()) return;

		const scrollTop = window.scrollY || document.documentElement.scrollTop;
		if (scrollTop >= 100 && scrollTop <= document.documentElement.scrollHeight - window.innerHeight * 2) {
			showFloatingNavTween.play();
		} else {
			showFloatingNavTween.reverse();
		}
	};

	window.addEventListener("scroll", floatingNavVisibilityHandler, { passive: true });
};

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	document.addEventListener("DOMContentLoaded", initApp);
} else {
	// `DOMContentLoaded` has already fired
	initApp();
}
